// extracted by mini-css-extract-plugin
export default {"detail":"detail-H7I_4","detailTitle":"detail-title-pMpdq","detailText":"detail-text-AxGZC","detailTime":"detail-time-KMdQH","detailContent":"detail-content-fKv46"};